import { textStyles as i } from "../../textStyles.es.js";
import { a } from "../../../chunk-OA3DH5LS-40f95340.js";
import { Input as t } from "./Input.es.js";
const o = a("MultiEmailInput").parts(
  "chip",
  "contentWrapper",
  "field",
  "fieldFocus",
  "input"
);
var r, n, e;
const u = {
  parts: o.keys,
  baseStyle: {
    field: {
      ...(r = t.baseStyle) == null ? void 0 : r.group,
      ...(n = t.variants) == null ? void 0 : n.primary.field,
      _groupFocusWithin: {
        ...(e = t.variants) == null ? void 0 : e.primary.group._groupFocusWithin
      },
      ...i.lg,
      display: "flex",
      flexWrap: "wrap",
      columnGap: "spacing-50",
      rowGap: "spacing-100",
      alignItems: "center",
      borderRadius: "radius-100",
      minHeight: "size-500",
      maxHeight: 328,
      padding: "spacing-100",
      _placeholder: {
        color: "primary.300"
      }
    },
    contentWrapper: {
      display: "flex",
      flexWrap: "inherit",
      gap: "spacing-100"
    },
    input: {
      ...i.lg,
      flex: 1,
      borderColor: "transparent",
      height: "full",
      minWidth: "140px",
      paddingInlineStart: "spacing-100",
      paddingInlineEnd: "spacing-100",
      _hover: {
        borderColor: "transparent",
        outlineColor: "transparent",
        outlineStyle: "none",
        outlineWidth: 0
      },
      _focusVisible: {
        borderColor: "transparent",
        outlineColor: "transparent",
        outlineStyle: "none",
        outlineWidth: 0
      },
      _autofill: {
        boxShadow: "0 0 0px 1000px white inset",
        border: "none"
      }
    }
  }
};
export {
  o as MultiEmailAnatomy,
  u as MultiInput
};
//# sourceMappingURL=MultiEmailInput.es.js.map
